import axios from '@service'
import { SAFETY_MFG_URL } from '@config'
import { HTTP_ERR_SUCCESS } from '@constant/api_status'
import { ERROR_DEFAULT_HTTP_REQUEST_FAIL } from '@constant/error'

// 选择项目列表
export default async function getChooseProjectListBenxiService(payload = {}) {
    const param = {
        url: `${SAFETY_MFG_URL}/project-temp/page`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        },
        timeout: 30000,
        data: payload
    }
    param.url = `${param.url}?current=${payload.current}&size=${payload.size}`

    const { data } = await axios(param)

    if (data.code === HTTP_ERR_SUCCESS) {
        return data.result || {}
    } else {
        throw new Error(data.errorMessage || ERROR_DEFAULT_HTTP_REQUEST_FAIL)
    }
}
